import {Button} from '@material-ui/core';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {makeName, TRANSFER_TYPES} from "./index";
import Utils from "../../../helpers/Utils";
import {setTransferCallEnvironment} from "../../../reducers/globalDialerV2/globalDialerSlice";
import ContactListSkeleton from "./ContactListSkeleton";
import PhoneNumber from "./PhoneNumber";

const CallTransfer = ({ search, initiateSecondCalling }) => {
    const {loadingContacts, contacts, transferCallEnvironment} = useSelector((state)=>(state.globalDialerV2));
    const dispatch = useDispatch();

    useEffect(() => {
        if (transferCallEnvironment.activeContact){
            dispatch(setTransferCallEnvironment({
                activeContact: null
            }));
        }
    }, [search]);

    return (
        <div className='callTransferWrapper'>
            <div>
                <div className='contactList' style={{ marginBottom: contacts[0] ? 16 : 0 }}>
                    {
                        loadingContacts ?
                            <ContactListSkeleton/> :
                            <div className='scrollBar'>
                                {
                                    contacts[0] ?
                                        contacts.map((item, index) => (
                                            <div key={index} onClick={()=>{
                                                if (transferCallEnvironment.activeContact?.id === item.id) {
                                                    dispatch(setTransferCallEnvironment({
                                                        activeContact: null
                                                    }));
                                                }else {
                                                    dispatch(setTransferCallEnvironment({
                                                        activeContact: item
                                                    }));
                                                }
                                            }} className={`contactItem ${transferCallEnvironment.activeContact?.id === item.id && 'selected'}`}>
                                                <span className='itemTitle'>{makeName(item)}</span>
                                                <span className='leftSide'>
                                                <span className='itemPhone'>
                                                    <PhoneNumber number={Utils.formatNumber(item.number)}/>
                                                </span>
                                            </span>
                                            </div>
                                        )) :
                                        search.length > 9 && Utils.validateMobileNumber(Utils.cleanPhoneNumber(search)) &&
                                        (
                                            <div style={{ marginBottom: 16 }}>
                                                <span className='nonContactMessage'>Not in your contacts</span>
                                                <div onClick={()=>{
                                                    dispatch(setTransferCallEnvironment({
                                                        activeContact: {
                                                            number: search
                                                        }
                                                    }))
                                                }} className={`contactItem ${transferCallEnvironment.activeContact?.number === search && 'selected'}`}>
                                                    <span className='itemTitle'>Unknown</span>
                                                    <span className='leftSide'>
                                                    <span className='itemPhone'>
                                                        <PhoneNumber number={Utils.formatNumber(search)}/>
                                                    </span>
                                                </span>
                                                </div>
                                            </div>
                                        )
                                }
                            </div>
                    }
                </div>
            </div>

            <div className='footerSection' >
                <Button
                    style={{ backgroundColor: '#3D50FF', textTransform: 'capitalize' }}
                    variant='contained'
                    color='primary'
                    fullWidth
                    disabled={!transferCallEnvironment.activeContact}
                    onClick={()=>initiateSecondCalling(TRANSFER_TYPES.BLIND)}
                >
                    Cold Transfer
                </Button>

                <Button
                    className='outlinedButton'
                    variant='outlined'
                    fullWidth
                    onClick={() => initiateSecondCalling(TRANSFER_TYPES.WARM)}
                    disabled={!transferCallEnvironment.activeContact}
                >
                    Warm Transfer
                </Button>
            </div>
        </div>
    );
};

export default CallTransfer;